module.exports = __webpack_public_path__ + "static/img/8.9857f9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/8.png
// module id = FpBU
// module chunks = 0